<template>
  <div class="@container flex shrink-0 grow flex-col gap-4">
    <template v-if="props.items">
      <template v-for="(buttons, section) in props.items" :key="section">
        <h3 class="text-heading-2 pb-2 pl-2 capitalize">{{ section }}</h3>
        <div
          class="grid-cols grid grid-cols-1 gap-2 @md:grid-cols-2 @xl:grid-cols-3 @2xl:grid-cols-4"
        >
          <RfButtonCard
            v-for="entry in buttons"
            :key="entry[props.valueKey]"
            :class="{
              'border-transparent! bg-white! outline-2! outline-blue-50! outline-solid':
                model && model[props.valueKey] === entry[props.valueKey],
            }"
            :image="entry.image"
            :title="titleAccessor(entry)"
            :description="descriptionAccessor(entry)"
            :tags="tagsAccessor ? tagsAccessor(entry) : []"
            @click="
              () =>
                model && model[props.valueKey] === entry[props.valueKey]
                  ? (model = null)
                  : (model = entry)
            "
          >
            <template v-if="entry.icon" #image>
              <component :is="entry.icon" class="m-auto h-14 w-10" />
            </template>
          </RfButtonCard>
        </div>
      </template>
    </template>
  </div>
</template>

<script setup>
import { computed } from "vue";
import RfButtonCard from "@/components/buttons/RfButtonCard.vue";

const model = defineModel({
  type: Object,
  default: null,
});
const props = defineProps({
  items: { type: [Array, Object], required: true },
  titleKey: { type: [String, Function], required: true },
  descriptionKey: { type: [String, Function], required: true },
  tagsKey: { type: [String, Function], default: null },
  valueKey: { type: String, default: "value" },
});

const toAccessor = key => (typeof key === "function" ? key : item => item[key]);

const titleAccessor = computed(() => toAccessor(props.titleKey));
const descriptionAccessor = computed(() => toAccessor(props.descriptionKey));
const tagsAccessor = computed(() => (props.tagsKey != null ? toAccessor(props.tagsKey) : null));
</script>
